import React from 'react'

import { useState } from 'react'
import { Briefcase, ChevronLeft, Shield } from 'lucide-react'
import { Button, cn } from '@wove/web-ui'
import { useNavigate } from 'react-router-dom'
import AccountSettings from './AccountSettings'
// import { DataProcessingSettings } from './DataProcessing'
// import { ApplicationSettings } from './ApplicationSettings'
import LoginAndSecurity from './LoginAndSecurity'
// import { IntegrationSettings } from './IntegrationSettings'
// import { TeamSettings } from './TeamSettings'

interface SettingsTab {
  id: string
  label: string
  icon: React.ReactNode
}

const tabs: SettingsTab[] = [
  {
    id: 'profile',
    label: 'Profile',
    icon: <Briefcase className="h-4 w-4" />,
  },
  // {
  //   id: 'application',
  //   label: 'Application',
  //   icon: <Settings className="h-4 w-4" />,
  // },
  // {
  //   id: 'data-processing',
  //   label: 'Data Processing',
  //   icon: <Globe className="h-4 w-4" />,
  // },
  // {
  //   id: 'integrations',
  //   label: 'Integrations',
  //   icon: <Mail className="h-4 w-4" />,
  // },
  // {
  //   id: 'team',
  //   label: 'Team',
  //   icon: <Users className="h-4 w-4" />,
  // },
  // {
  //   id: 'notifications',
  //   label: 'Notifications',
  //   icon: <Bell className="h-4 w-4" />,
  // },
  {
    id: 'security',
    label: 'Security',
    icon: <Shield className="h-4 w-4" />,
  },
]

export default function SettingsLayout() {
  const navigate = useNavigate()
  const [activeTab, setActiveTab] = useState('profile')

  const scrollToSection = (id: string) => {
    setActiveTab(id)
    const element = document.getElementById(id)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }

  return (
    <div className="h-screen flex flex-col">
      <div className="flex items-center p-3">
        <Button
          variant="ghost"
          size="icon"
          className="mr-2"
          onClick={() => navigate('/')}
          aria-label="Back to dashboard"
        >
          <ChevronLeft className="h-4 w-4" />
        </Button>
        <h1 className="text-3xl font-bold tracking-tight">Settings</h1>
      </div>

      <div className="flex flex-col md:flex-row gap-8 flex-1 min-h-0">
        <aside className="md:w-64 shrink-0">
          <div className="flex h-full flex-col gap-2 p-4">
            <nav className="grid gap-1 py-2">
              {tabs.map((tab) => (
                <Button
                  key={tab.id}
                  variant="ghost"
                  className={cn(
                    'flex items-center gap-3 rounded-lg px-3 py-2 text-muted-foreground transition-all hover:text-foreground justify-start',
                    activeTab === tab.id && 'bg-muted font-medium text-foreground',
                  )}
                  onClick={() => scrollToSection(tab.id)}
                >
                  {tab.icon}
                  {tab.label}
                </Button>
              ))}
            </nav>
          </div>
        </aside>

        <div className="flex-1 space-y-8 overflow-auto pr-4">
          <AccountSettings />
          {/* <ApplicationSettings />
          <DataProcessingSettings />
          <IntegrationSettings />
          <TeamSettings /> */}
          <LoginAndSecurity />
        </div>
      </div>
    </div>
  )
}
